var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"rounded-circle calendar-button",staticStyle:{"cursor":"default"},attrs:{"variant":"none"}},[_c('i',{staticClass:"fa-solid fa-calendar-days"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }